










































































































































































import { ALForm } from '@/common/component.types';

import { PropType } from 'vue';

import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import { IQuoteFreightEstimates, QuoteFreightEstimates } from '@/models';

import ALDialog from '../core/Dialog/ALDialog.vue';
import { cloneDeep } from 'lodash';

const baseMixins = mixins(Proxyable);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuoteFreightsEstimatesFormDialog',
    components: { ALDialog },

    props: {
      estimates: { type: Object as PropType<IQuoteFreightEstimates> }
    },

    data() {
      return {
        editableEstimates: null as IQuoteFreightEstimates | null,
        quantityRules: [(v: any) => v >= 0 || 'Quantity cannot be less than 0'],
        estimatesFormValid: false
      };
    },

    watch: {
      internalValue(value: boolean) {
        if (value) {
          if (this.estimates) {
            this.editableEstimates = cloneDeep(this.estimates);
          } else {
            this.editableEstimates = new QuoteFreightEstimates();
          }
        }
      }
    },

    methods: {
      close() {
        this.internalValue = false;
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      save() {
        if (this.validateForm()) {
          // only update quantities when saving
          this.$emit('update:estimates', this.editableEstimates);
          this.close();
        }
      }
    }
  });
